import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3319f954"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "input_label mb-3" }
const _hoisted_2 = { class: "date_icon" }
const _hoisted_3 = ["onClick"]

import { ref, watch, withDefaults } from 'vue'
import BirthdayIcon from './icons/BirthdayIcon.vue';
import CleanIcon from './icons/CleanIcon.vue';

interface IProps {
    date: Array<string> | string;
    appendIcon?: boolean;
    isRange?: boolean;
    label?: string;
}



export default /*#__PURE__*/_defineComponent({
  __name: 'AtomCalendar',
  props: {
    date: {},
    appendIcon: { type: Boolean },
    isRange: { type: Boolean, default: true },
    label: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const internalValue = ref(props.date);
const emit = __emit;

watch(
    () => props.date,
    (newValue) => {
        internalValue.value = newValue;
    }
);

watch(
    () => internalValue.value,
    (newInternalValue) => {
        emit('update:modelValue', newInternalValue);
    }
);

const customFormat = (date) => {
    if (Array.isArray(date) && date.length === 2) {
        const [start, end] = date;
        return `${start.getDate().toString().padStart(2, '0')}/${(start.getMonth() + 1).toString().padStart(2, '0')}/${start.getFullYear()} - ${end.getDate().toString().padStart(2, '0')}/${(end.getMonth() + 1).toString().padStart(2, '0')}/${end.getFullYear()}`;
    } else if (date instanceof Date) {
        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
    } else {
        return '';
    }
};

const dayNames = ref(['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb', 'Dom']);

return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.label ? _ctx.label : 'Data:'), 1),
    _createVNode(_component_VueDatePicker, {
      class: "custom-date-picker",
      range: _ctx.isRange,
      modelValue: internalValue.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internalValue).value = $event)),
      placeholder: "Clique para selecionar",
      "enable-time-picker": false,
      "day-names": dayNames.value,
      "auto-apply": "",
      locale: "pt-BR",
      format: customFormat,
      teleport: true,
      "min-date": new Date(2024, 0, 1)
    }, {
      "input-icon": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(BirthdayIcon)
        ])
      ]),
      "clear-icon": _withCtx(({ clear }) => [
        _createElementVNode("div", {
          onClick: clear,
          style: {"padding-right":"1rem"}
        }, [
          _createVNode(CleanIcon)
        ], 8, _hoisted_3)
      ]),
      _: 1
    }, 8, ["range", "modelValue", "day-names", "min-date"])
  ]))
}
}

})